import { useEffect, useState } from "react";

export type NotificationVariant =
  | "success"
  | "error"
  | "warning"
  | "info"
  | undefined;

export function useTableNotifications() {
  const [successForNotification, setSuccessForNotification] =
    useState<boolean>(false);
  const [notificationMessage, setNotificationMessage] = useState<any>("");
  const [notificationVariant, setNotificationVariant] =
    useState<NotificationVariant>();

  const resetStateOnCloseNotification = () => {
    setSuccessForNotification(false);
  };

  const notify = (message: any, variant: NotificationVariant) => {
    setNotificationMessage(message);
    setNotificationVariant(variant);
    setSuccessForNotification(true);
  };

  useEffect(() => {
    if (successForNotification) {
      const timer = setTimeout(() => {
        setSuccessForNotification(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [successForNotification]);

  return {
    successForNotification,
    setSuccessForNotification,
    notificationMessage,
    setNotificationMessage,
    notificationVariant,
    setNotificationVariant,
    notify,
    resetStateOnCloseNotification,
  };
}
